import { Badge as BsBadge } from 'react-bootstrap';

/**
 * @param {'primary' | 'secondary' | 'success' | 'danger' | 'warning'} variant
 * @param {string} [className]
 * @param {string} [tooltip]
 * @param children
 */
export function Badge({ variant = 'primary', className, tooltip, children }) {
    return (
        <BsBadge variant={variant} className={className} data-uk-tooltip={tooltip}>
            {children}
        </BsBadge>
    );
}
